import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';

export default function Profile() {
  const { user, logout } = useAuth();

  return (
    <Layout>
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Profile</h2>

          <div className="flex items-center gap-6 mb-6">
            {user?.picture && (
              <img
                src={user.picture}
                alt={user.name}
                className="w-20 h-20 rounded-full"
              />
            )}
            <div>
              <h3 className="text-xl font-semibold">{user?.name}</h3>
              <p className="text-gray-600">{user?.email}</p>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6">
            <h3 className="font-semibold mb-4">Storage Settings</h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between p-3 border rounded-lg">
                <div>
                  <p className="font-medium">Google Drive Sync</p>
                  <p className="text-sm text-gray-600">Automatically backup to Google Drive</p>
                </div>
                <button className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-sm font-medium">
                  Connected
                </button>
              </div>
              <div className="flex items-center justify-between p-3 border rounded-lg">
                <div>
                  <p className="font-medium">Cloudflare R2</p>
                  <p className="text-sm text-gray-600">Primary storage location</p>
                </div>
                <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg text-sm font-medium">
                  Active
                </span>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6 mt-6">
            <button
              onClick={logout}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
